module.exports = __webpack_public_path__ + "img/freespin1.5cd5664b.png";